import React from 'react';
import type { HeadlineSegment } from '../../types/landing';
type LandingHeroProps = {
  eyebrow: string;
  headline: HeadlineSegment[];
  intro: string;
};
export function LandingHero({
  eyebrow,
  headline,
  intro
}: LandingHeroProps) {
  return <section className="mx-auto max-w-3xl px-6 pt-8 text-center md:pt-10" data-id="element-28" data-mp="2sc90b46xcist">
      <p className="font-display text-lg italic text-ink/80" data-id="element-29" data-mp="2xak5v2q6s758">{eyebrow}</p>
      <h1 className="mt-3 [text-wrap:balance] font-heading text-[1.75rem] font-light uppercase leading-[1.25] tracking-[0.06em] text-logo md:text-[2rem]" data-id="element-30" data-mp="3kyk04cmpifok">
        {headline.map((segment, i) => {
        if (segment.emphasis === 'underline') {
          return <span key={i} className="underline decoration-1 underline-offset-[6px]" data-id="element-31" data-mp="3b39z9s81oecd">
                {segment.text}
              </span>;
        }
        if (segment.emphasis === 'strong') {
          return <strong key={i} className="font-semibold underline decoration-2 underline-offset-[6px]" data-id="element-32" data-mp="24l3jomt5tmhg">
                {segment.text}
              </strong>;
        }
        return <span key={i} data-id="element-33" data-mp="2tffc32czlhws" data-mpi={i}>{segment.text}</span>;
      })}
      </h1>
      <p className="mx-auto mt-5 max-w-3xl font-body text-[15px] leading-relaxed text-ink/80" data-id="element-34" data-mp="37dvsjl0nims4">
        {intro}
      </p>
    </section>;
}